export default onPageTransitionEnd;

function onPageTransitionEnd(pageContext: Vike.PageContext) {
  if (typeof document !== 'undefined') {
    const html = document.documentElement;
    const body = document.querySelector('body');

    const pathnameOriginal = pageContext.urlOriginal || pageContext.urlParsed?.pathnameOriginal;
    const pathname = pageContext.urlPathname || pageContext.urlParsed?.pathname;

    body!.classList.remove('page-is-transitioning');

    document.getElementById('transitionstyle')?.remove();

    // Close the mobile sidebar after any navigation. The <aside>'s own onClick
    // handles links inside it, but the user-dropdown menu is portal-rendered
    // to <body>, so its links never fire that handler. Resetting the checkbox
    // here is a no-op on desktop (the sidebar is `md:translate-x-0` regardless).
    const navCheckbox = document.getElementById('nav-checkbox') as HTMLInputElement | null;
    if (navCheckbox?.checked) {
      navCheckbox.checked = false;
    }

    if (html!.dataset.nextUrl === pathnameOriginal) {
      html!.dataset.nextUrl = undefined;
    }

    html!.dataset.urlOriginal = pathnameOriginal;
    html!.dataset.urlPathname = pathname;

    if (
      pathnameOriginal === pathname &&
      (pageContext as unknown as { _comesDirectlyFromServer: boolean })._comesDirectlyFromServer
    ) {
      console.log('same');
      // navigate(data.urlPathname);
    }
  }
}
